'use client'

import { useState } from 'react'
import { BellIcon, BellAlertIcon } from '@heroicons/react/24/solid'

enum BellState {
  OFF = 'off',
  ON = 'on',
}

const Bell = () => {
  const [bell, setBell] = useState<BellState>(BellState.OFF)

  //cycle: light > dark > system
  const cycleBell = () => {
    if (bell === BellState.ON) {
      setBell(BellState.OFF)
    } else {
      setBell(BellState.ON)
    }
  }

  if (bell === BellState.OFF) {
    return (
      <div className="h-7 w-13">
        <button
          type="button"
          aria-label="notifications"
          tabIndex={0}
          onClick={() => cycleBell()}
          className="h-7 w-7 focus-custom flex rounded-full bg-background-light text-foreground-light dark:bg-background-dark dark:text-foreground-dark justify-center items-center border-custom"
        >
          <BellIcon className="h-[22px] w-[22px] rounded-full" />
        </button>
      </div>
    )
  }
  return (
    <button
      type="button"
      aria-label="notifications"
      tabIndex={0}
      onClick={() => cycleBell()}
      className="h-7 w-13 focus-custom flex  rounded-full bg-background-light text-foreground-light dark:bg-background-dark dark:text-foreground-dark justify-center items-center border-custom"
    >
      <BellAlertIcon className="h-[22px] w-[22px] rounded-full" />
      <div className="w-[3px]"></div>
      <span className="h-[21px] w-[21px] rounded-full bg-foreground-light dark:bg-foreground-dark text-background-light dark:text-background-dark flex justify-center items-center">
        9
      </span>
    </button>
  )
}

export default Bell
